import { connect } from 'react-redux';
import { getIsMobile } from 'src/store/view/selectors';
import { applySingleChoiseFilters } from '../../store/flights-filters/actions';
import {
  getRawFlightsFilterData,
  minPriceForFilterByTourIdSelector,
} from '../../store/flights-filters/selectors';
import { LuggageFilterPanel } from './LuggageFilterPanel';
import type { FlightsFilter } from '../../store/flights-filters';

const mapStateToProps = (state) => ({
  filterData: getRawFlightsFilterData(state, 'luggage_types'),
  isMobile: getIsMobile(state),
  getMinPrice: (filterData: Partial<FlightsFilter>) =>
    minPriceForFilterByTourIdSelector(state, filterData),
});

const mapDispatchToProps = {
  applyFilters: applySingleChoiseFilters,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(LuggageFilterPanel);
